export const ADVISOR_CSV_IMPORT_COLUMNS = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'organizationName',
  'organizationSieId',
  'agencyName',
  'agencySieId',
  'sieId',
  'addviseoId',
  'exitDate',
] as const;

export type AdvisorCsvImportColumn = (typeof ADVISOR_CSV_IMPORT_COLUMNS)[number];
